import { Button } from "@/components/flexkit/Button";
import {
    Dialog,
    DialogHeader,
    DialogTitle,
    DialogContent,
    DialogBody,
    DialogFooter,
    DialogClose,
} from "@/components/podkit/dialog/Dialog";
import { ExternalLink } from "@/components/podkit/typography/ExternalLink";
import { Text } from "@/components/podkit/typography/Text";
import { formatRepoUrlForDisplay } from "@/format/url";
import { TrackLocations } from "@/hooks/use-segment";
import { pluralize } from "@/utils/strings";
import type { PlainMessage } from "@bufbuild/protobuf";
import type { SearchRepositoriesResponse_Repository } from "gitpod-next-api/gitpod/v1/runner_pb";
import type { FC } from "react";

const MAX_REPOSITORIES_TO_SHOW = 8;

export const RepoTriggerSampleDialog: FC<{
    repositories: PlainMessage<SearchRepositoriesResponse_Repository>[];
    open: boolean;
    onOpenChange: (open: boolean) => void;
}> = ({ repositories, open, onOpenChange }) => {
    const visibleRepositories = repositories.slice(0, MAX_REPOSITORIES_TO_SHOW);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-track-location={TrackLocations.WorkflowEditPageRepoTriggerSampleDialog}>
                <DialogHeader>
                    <DialogTitle>
                        Preview sample ({Math.min(MAX_REPOSITORIES_TO_SHOW, repositories.length)} of{" "}
                        {repositories.length} {pluralize(repositories.length, "repository", "repositories")})
                    </DialogTitle>
                </DialogHeader>
                <DialogBody className="p-0">
                    <ul className="flex flex-col gap-2">
                        {visibleRepositories.map((repository) => (
                            <li
                                className="flex flex-col rounded-md border border-border-subtle px-3 py-2"
                                key={repository.name}
                            >
                                <ExternalLink className="text-content-brand hover:underline" href={repository.url}>
                                    {formatRepoUrlForDisplay(repository.url)}
                                </ExternalLink>
                                <Text className="text-content-secondary">{repository.name}</Text>
                            </li>
                        ))}
                    </ul>
                </DialogBody>
                <DialogFooter className="justify-end">
                    <DialogClose asChild>
                        <Button
                            variant="outline"
                            data-tracking-id="workflow-edit-page-repo-trigger-sample-dialog-close"
                        >
                            Close
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
